<template>
    <div>
        <!-- Header section -->
        <header class="header-section">
            <div class="container text-right">
                <div class="page-info">
                    <h2>Услуги</h2>
                    <div class="page-links">
                        <router-link to="/">Начало</router-link>
                        <span class="active">Услуги</span>
                    </div>
                </div>
            </div>
        </header>
        <!-- Header section end -->
        <div class="container mt-5 service">
            <div class="row">
                <div  v-for="service in services" :key="service.key" class="col-md-6 mb-3">
                    <router-link :to="{name: 'detailService', params: { id: service.key }}">
                        <!--<div class="card-img-top" style="height: 150px;">-->
                            <!--<img class="img-fluid img-thumbnail" :src="service.image" alt="">-->
                        <!--</div>-->
                        <div class="list-service-item text-muted">
                            {{ service.name }}
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { db } from '../../firebase';

    export default {
        data() {
            return {
                services: []
            }
        },
        created() {
            db.collection('services').onSnapshot((snapshotChange) => {
                this.services = [];
                snapshotChange.forEach((doc) => {
                    this.services.push({
                        key: doc.id,
                        name: doc.data().name,
                        description: doc.data().description,
                        image: doc.data().image,
                    })
                });
            })
        }
    }
</script>
<style>
    .list-service-item {
        padding: 20px;
        background-color: rgba(0, 0, 0, 0.03);
    }
</style>
